import React from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { MenuItem } from '../components/Menu';
import editIcon from '../icons/non-prefilled/16x16/edit.svg';
import UIActions from '../ui/UIActions';

interface EditSidebarSectionMenuItemProps {
  sectionId: string;
}
const EditSidebarSectionMenuItem = ({
  sectionId,
}: EditSidebarSectionMenuItemProps) => {
  const dispatch = useAppDispatch();
  return (
    <MenuItem
      icon={editIcon}
      onClick={() => dispatch(UIActions.setSelectedSectionId(sectionId))}
    >
      Edit section
    </MenuItem>
  );
};

export default EditSidebarSectionMenuItem;
